module.exports = __webpack_public_path__ + "img/4.60fc45ef.jpg";